import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { LOG_OUT } from "../modules/auth/store/actionTypes";

// Importing all module reducers
import authReducer from "../modules/auth/store/reducer";
import commonReducer from "./commonReducer";
import tableReducer from "core/modules/table/reducer";
import dashboardReducer from "modules/dashboardAndReports/store/reducer";
import transactionReducer from "modules/transactions/store/reducer";

const reducer = combineReducers({
	common: commonReducer,
	auth: authReducer,
	tableList: tableReducer,
	dashboard: dashboardReducer,
	transactions: transactionReducer,
});

const appReducer = (state: any, action: any) => {
	if (action.type === LOG_OUT) {
		state = undefined;
	}
	return reducer(state, action);
};

export const store = configureStore({
	reducer: appReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
